var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showFavouriteProducts)?_c('FavouriteProductsSection',{attrs:{"favouriteProducts":_vm.favouriteProducts,"units":_vm.units,"products":_vm.products,"processedArea":_vm.processedArea},on:{"addFavouriteProducts":_vm.addFavouriteProducts}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }